module.exports = __webpack_public_path__ + "img/1.79d7b6c2.jpg";